module.exports = {
    newIcon: 'NEW',
    genericRegisterCardErrorMessage: 'There was a problem linking the card please try again later',
    linkCardSuccessMessage: 'Card successfully linked',
    cardAlreadyLinked: 'This card is already linked to this account',
    invalidCvvErrorMessage: 'Please enter a valid cvv number',
    invalidCardNumberErrorMessage: 'Please enter a valid card number',
    invalidCardAndCvvErrorMessage: 'Please enter a valid card and cvv number',
    feedback: {
        buttonText: 'Sparks Colleague Trial Feedback',
        line1: 'Problems with the new Sparks experience?',
        line2: 'Let us know by filling out this survey.',
        mdWidth: 599,
        smWidth: 286
    },
    cardNotScanningMessage1: 'Still having issues in scanning?',
    cardNotScanningMessage2: 'Just ask a customer assistant to type your card number in',
    fullDetailsText: 'Full details',
    rewardCardTitle: 'Claim your FREE treat!',
    rewardCardAddedTitle: 'Your FREE treat...enjoy!',
    findStore: 'Find a store nearby',
    findStoreHref: 'https://www.marksandspencer.com/MSResStoreFinderGlobalBaseCmd?langId=-24&storeId=10451&catalogId=11551',
    instoreOnly: 'IN STORE ONLY',
    instoreTreat: 'IN-STORE GIFT',
    instoreAndOnline: 'IN STORE & ONLINE',
    onlineOnly: 'ONLINE ONLY',
    reward: {
        product: {
            titlePrefix: '',
            description: 'Pick up a bag of your choice from our range of Percy Pigs and his friends',
            claimTitle: 'HOW TO CLAIM',
            claimStep1: 'Hit the + icon to add to your Sparks card',
            claimStep1Done: 'You\'ve successfully added a gift to your card',
            claimStep1SRP: 'You\'ve successfully added a reward to your card',
            instore: {
                claimStep2: 'Pick up your treat in store',
                claimStep2b: 'Now pick up your treat in store',
                claimStep2SRP: 'Now pick up your reward in store',
                claimStep3: 'Scan your card at the checkout',
                claimNote: 'PLEASE NOTE : This product may not be available in all stores.'
            },
            instoreAndOnline: {
                claimStep2: 'Pick up your treat in store or add it to your bag online',
                claimStep3: 'Scan your card at the checkout and the discount will be automatically applied',
                claimNote: 'PLEASE NOTE : This product is subject to availability.'
            },
            online: {
                claimStep2: 'Add to your bag',
                claimStep3: 'Discount will be automatically applied',
                claimNote: 'PLEASE NOTE : This product is subject to availability.'
            },
            singleUse: 'SINGLE USE : Can be used only once in a single transaction. Subject to availability',
            showStoreListText: 'SHOW STORE LIST',
            terms: 'TERMS AND CONDITIONS'
        },
        voucher: {
            titlePrefix: '',
            description: 'Pick up a bag of your choice from our range of Percy Pigs and his friends',
            claimTitle: 'HOW TO CLAIM',
            claimStep1: 'Add the voucher to your card',
            claimStep3: 'Discount will be automatically applied',
            instore: {
                claimStep2: 'Shop in store'
            },
            instoreAndOnline: {
                claimStep2: 'Shop in store or online'
            },
            online: {
                claimStep2: 'Shop online'
            },
            singleUse: 'SINGLE USE : Can be used only once in a single transaction. Subject to availability',
            showStoreListText: 'SHOW STORE LIST',
            terms: 'TERMS AND CONDITIONS'
        },
        pickATreat: {
            leftContentTopText: 'Choose from:',
            leftContentImageSeperator: '-OR-',
            titlePrefix: 'WHAT\'S WAITING FOR YOU?',
            description: 'Enjoy a gift on us - simply pick it up next time you shop in store.',
            buttonPreClick: 'Add gift to card',
            buttonPostClick: 'Added to card',
            claimTitle: 'HOW TO CLAIM',
            claimStep3: ' Scan your gift and Sparks card at the till - it\'s on us',
            claimNote: 'PLEASE NOTE: Gifts may not be available in all stores',
            preClick: {
                claimStep1: ' Hit the + icon to add to your Sparks card',
                claimStep2: ' Come in store and select your preferred gift'
            },
            postClick: {
                claimStep1: ' You\'ve successfully added a gift to your card ',
                claimStep2: ' Now choose your preferred gift in store'
            },
            singleUse: 'SINGLE USE : Can be used only once in a single transaction. Subject to availability',
            showStoreListText: 'SHOW STORE LIST',
            terms: 'TERMS AND CONDITIONS'
        }
    },
    streak: {
        titlePrefix: 'EARN A FREE ',
        descriptiona: 'Collect a stamp when you buy an M&S ',
        descriptionb: ' in store. You\'ll earn one stamp per ',
        descriptionc: '. Collect 4 stamps to earn a free ',
        descriptiond: '.',
        buttonPreClick: 'Start earning',
        buttonPostClick: 'You\'ve started earning',
        claimTitle: 'HOW TO EARN',
        claimStep3: 'Scan your ',
        claimStep3b: ' and Sparks card at the till to earn your stamps',
        preClick: {
            claimStep1: ' Hit \'Start earning\' to link Sparks Stamps to your Sparks card',
            claimStep2: ' Come in store and select your preferred '
        },
        postClick: {
            claimStep1: ' You\'ve successfully linked Sparks Stamps to your Sparks card ',
            claimStep2a: ' Now choose your preferred ',
            claimStep2b: ' in store'
        },
        terms: 'TERMS AND CONDITIONS',
        singleUseText1: 'SINGLE USE: This offer can only be used once to earn one free ',
        singleUseText2: '. Subject to availability.',
        streakCompletePrefix: 'Enjoy your free '
    },
    spendAndSave: {
        titlePrefix: 'EARN YOUR save REWARD',
        description: 'Spend SPEND on M&S food when you shop in store, either in a single transaction or over multiple visits, and we\'ll give you SAVE off your next in-store shop.',
        buttonPreClick: 'Start earning',
        buttonPostClick: 'You\'ve started earning',
        claimTitle: 'HOW TO EARN',
        claimStep2a: 'Now shop ',
        claimStep2b: ' in store',
        claimStep3: 'Scan your items and Sparks card at the till to track your progress',
        preClick: {
            claimStep1: ' Hit \'Start earning\' to link Spend & Save to your Sparks card'
        },
        postClick: {
            claimStep1: 'You\'ve successfully linked the reward to your Sparks account'
        },
        terms: 'TERMS AND CONDITIONS',
        singleUseText1: 'SINGLE USE: This offer can only be used once to earn one free ',
        singleUseText2: '. Subject to availability.'
    },
    newOffersAdviceText: 'Add the ones you like and they\'ll be applied at checkout',
    newOfferAdviceTextOne: 'Like the offer shown? Add it and it\'ll be applied at checkout',
    addedOffersAdviceText: 'These offers will be automatically applied at the checkout',
    activateAllOffersButtonText: 'Add all offers',
    activateAllOffersAndRewardsButtonText: 'Add all',
    mobileCarouselShrinkPercentage: 10,
    shopOfferButtonText: 'Shop the offer',
    findAStoreButtonText: 'Find a store',
    noNewOffersTitle: 'You\'ve added all your Sparks offers',
    noNewOffersText: 'They\'re waiting on your card, so why not start shopping?',
    noNewOffersButtonText: 'See your offers',
    viewMSOffersHref: '/c/offers',
    noAddedOffersTitle: 'Oh no, you haven\'t loaded any offers!',
    noAddedOffersText: 'Start adding new offers to your Sparks card below',
    noAddedOffersButtonText: 'See new offers',
    noOffersTitle: 'You don\'t have any offers at the moment',
    noOffersText: 'Don\'t worry we still have plenty of M&S offers you can use',
    noOffersButtonText: 'View M&S offers',
    charityText: 'Your Sparks charity',
    chosenCharityText: 'For your charity, we\'ve raised',
    editCharityText: 'Change charity',
    editCharityLink: '/ie/mysparks/mycharity',
    editCharityHubLink: '/ie/mysparks/mycharity?anchorCharitySettings=true',
    popularItemsText: 'POPULAR ITEMS IN THIS OFFER',
    readTermsText: 'Read complete terms and conditions',
    addToCardButtonText: 'Add to card',
    linkCardText: 'Link physical card',
    cardNotScanningText: 'Card not scanning?',
    newOffersToggleText: 'New offers',
    offersAddedToggleText: 'Offers added',
    bannerTitleText: 'GOOD THINGS HAPPEN EVERY TIME YOU SHOP',
    holdingPageTitleText: 'ACTIVATE YOUR SPARKS ACCOUNT',
    holdingPageTitleDesc: 'Check your email and activate your account to start receiving the benefits of Sparks!',
    holdingPageContentText: 'Didn\'t receive an email?',
    holdingPageContentDesc: 'Check your junk email or resend',
    holdingPageCtaText: 'Resend activation email',
    holdingPageCtaUrl: '/TODO',
    welcomeXText: 'Welcome ',
    okText: 'OK',
    errorHeader: 'Unable to add offer',
    errorDesc: 'Unable to add your selected offer at this moment',
    offersAddedLabel: 'All offers added to sparks card',
    offerAppliedLabel: 'Add the ones you like and they\'ll be applied at checkout',
    smWindowBreakpoint: 600,
    mdWindowBreakpoint: 768,
    lgWindowBreakpoint: 1024,
    xlWindowBreakpoint: 1280,
    cardsAcrossWindow: 3,
    otherCharitiesTitle: 'Other Charities',
    chooseCharityTitle: 'YOU CURRENTLY SUPPORT',
    chooseCharityName: 'All our charities',
    chooseCharityText: 'Choose a charity',
    chooseCharityLink: '/ie/mysparks/mycharity',
    chooseCharityHubLink: '/ie/mysparks/mycharity?anchorCharitySettings=true',
    hubLink: '/ie/mysparks',
    allCharityRaisedTitle: 'In total, you\'ve helped us raise',
    moreInfoCharityText: 'More info',
    loginUrl: '/webapp/wcs/stores/servlet/MSLogoff?catalogId=11551&langId=-24&storeId=10451&rememberMe=true&WcUseHttps=true&viewTaskName=RedirectView&URL=',
    charitySettingTitle: 'Donating with Sparks',
    charitySettingsText: 'Every time you shop with your Sparks card we\'ll donate to your chosen charity – and now, there are even more to choose from.',
    charitySettingsTextWithFootnote: 'Every time you shop with Sparks, we\'ll donate to your chosen charity*. You can update your chosen charity** at any time, or if you\'d prefer to spread your donations equally, you can choose to \'support all charities\'',
    charityFootnote: '*For every transaction you make where you scan your Sparks card or are logged in to M&S with your Sparks account, M&S will donate 1c to charity.<br>**The good causes M&S supports through Sparks include both registered charities and social enterprises',
    supportAllCharitiesButtonText: 'Support all charities',
    supportingAllCharitiesConfirmationBoxText: 'Supporting all charities',
    sessionInactiveTime: 1800,
    charityButtonText: 'See all charities',
    bannerContainerTitleForJoinSparks: 'From big treats to little thank yous and a charity donation with every purchase',
    appDownloadSectionTitle: 'SCAN YOUR CARD FOR GOOD THINGS EVERY TIME YOU SHOP',
    appDownloadBoldText: 'Your Sparks card is also digital',
    appDownloadBodyText: 'Download the M&S app to scan your card straight from your phone, and keep track of offers and rewards.',
    appDownloadFooterText1: 'Need help',
    appDownloadFooterText2: 'downloading the app?',
    appDownloadFooterLinkText: 'Sparks FAQs',
    sparksFAQsLinke432: 'https://www.marksandspencer.com/ie/c/mobile-apps',
    appStoreAppDownloadLink: 'https://mandsapp.onelink.me/256943915/e6268bb8',
    googlePlayAppDownloadLink: 'https://mandsapp.onelink.me/256943915/8215c07a',
    signin: 'Sign in',
    register: 'Register',
    joinsparks: 'Join Sparks',
    seeYourOffersButtonText: 'View Sparks offers',
    sparksBenefitsTitleNonSparksCustomer: 'WELCOME TO SPARKS AND<BR>REWARDS YOU\'LL LOVE',
    sparksBenefitsTitleSparksCustomer: 'WE\'RE KEEPING THE THINGS YOU LOVE',
    sparksBenefitsTitleNonSparksCustomerSm: 'WELCOME TO SPARKS<BR>AND REWARDS YOU\'LL<BR>LOVE',
    sparksBenefitsTitleSparksCustomerAddThese: 'AND ADDING THESE.....',
    sparksBenefitsPersonalisedOffers: 'Offers just for you',
    sparksBenefitsPersonalisedOffersDesc: 'Get personalised offers on the things you love.',
    sparksBenefitsCharityDonation: 'A charity donation with every purchase',
    sparksBenefitsCharityDonationDesc: 'Whenever you scan your card, we\'ll donate to your chosen charity',
    sparksBenefitsLittleThankYous: 'Little thank yous, just because',
    sparksBenefitsLittleThankYousDesc: 'Every week, we\'ll surprise some lucky customers with a little gift',
    sparksBenefitsChanceToGet: 'The chance to get what you\'re buying for free',
    sparksBenefitsChanceToGetDesc: 'We\'ll treat a Sparks customer every week in every store to the shopping they’re buying right there and then',
    sparksBenefitsChanceToWin: 'Plus there\'s<BR>even more…',
    sparksBenefitsChanceToWinDesc: 'We\'ll be giving away thousands of<BR>pounds to spend at M&S, in store or<BR>online. Imagine that!',
    registerFromJoinsparksLink: '/webapp/wcs/stores/servlet/MSResUserRegistration?catalogId=11551&myAcctMain=1&langId=-24&storeId=10451&isSparksRelaunch=Y&intid=sparksnav_landing_register_<button_location>',
    analyticsAllCharitiesTxt: 'all charities',
    analyticsWelcomeOfferPromptInfoText: 'Activate your Sparks offers before you shop',
    signInFromJoinsparksLinkPart1: '/webapp/wcs/stores/servlet/MSResLogin?catalogId=11551&langId=-24&storeId=10451&isSparksRelaunch=Y&rememberMe=true&WcUseHttps=true&viewTaskName=RedirectView&intid=sparksnav_landing_signin_<button_location>&URL=',
    signInFromJoinsparksLinkPart2: '/ie/mysparks',
    marketingPreferencesTitle1: 'Marketing preferences',
    marketingPreferencesTitle2: 'Never miss a thing',
    marketingPreferencesDesc: 'We\'d like to send you exclusive offers, rewards, promotions and news',
    marketingPreferencesOption1: 'Yes, I\'d like to receive updates via email and/or text about your products and services and those offered by your partners',
    marketingPreferencesOption2: 'No thanks',
    marketingPreferencesChangeMind: 'If you change your mind, you can opt out at any time.',
    joinSparksLink: '/ie/joinsparks',
    singleUseHeader: 'SINGLE USE OFFER',
    singleUseText: 'Can be used only once in a single transaction. Subject to availability.',
    tncsHeader: 'TERMS & CONDITIONS',
    colleagueFeedbackSurveyUrl: 'https://www.surveymonkey.co.uk/r/ZJGHQRP?channel=web&user=$sparksCardNumber&page=$feedbackPageName',
    onboardingExistingUserTitle1: 'SPARKS IS HERE',
    onboardingNewUserTitle1: 'WELCOME TO SPARKS',
    onboardingExistingUserDesc1: 'Take a look at what\'s in store for you.',
    onboardingNewUserDesc1: 'We can\'t wait for you to enjoy all the new benefits! Take a look at what\'s in store for you.',
    onboardingTitle2: 'OFFERS JUST FOR YOU',
    onboardingNewTitle2: 'PERSONALISED OFFERS',
    onboardingDesc2: 'We\'ll give you personalised offers based on the things you love. Add them and they\'ll be applied at checkout.',
    onboardingNewDesc2: 'We\'ll give you personalised offers based on the things you love. Add them and they\'ll be applied at checkout.',
    onboardingTitle3: 'CHARITY DONATION',
    onboardingDesc3: 'Every time you shop with your digital Sparks card we\'ll donate to your chosen charity.',
    onboardingTitle4: 'LOOK OUT FOR TREATS',
    onboardingDesc4: 'We\'ll surprise lucky customers with little thank yous, and every week in every store someone will get their shopping for free!',
    onboardingNewTopTitle5: 'YOUR DIGITAL CARD',
    onboardingNewTitle5: 'YOU\'RE READY TO GO!',
    onboardingNewDesc5: 'Just scan your Sparks card every time you shop. Don\'t forget to <a>link</a> your physical Sparks card to your account.',
    onboardingPreviousText: 'Previous',
    onboardingNextText: 'Next',
    onboardingTreatLink: 'Get your offers',
    redeemedTagText: 'REDEEMED',
    charityDonationEmptyTitle: 'THIS IS A NEW CHARITY',
    charityDonationEmptyDesc: 'Check back soon to see how<br>much you\'ve raised',
    hubAppDownloadSectionTitle: 'Here\'s €<xx> on us',
    hubAppDownloadBoldText: 'Login to the M&S app on your mobile device to claim your treat',
    hubAppDownloadBodyText: 'Don\'t forget you can now scan your Sparks card straight from your phone',
    onboardingExisitingUserScreenNames: ['Your new and improved sparks', 'We are keeping offers', 'Adding more charities', 'Look out for treats'],
    onboardingNewUserScreenNames: ['Welcome to sparks', 'Personalised offers', 'Charity contribution', 'Look out for treats'],
    transitionJourneyText: 'WELCOME_TRANSITION_JOURNEY',
    newJourneyText: 'WELCOME_NEW_CUST_JOURNEY',
    errorMessage: 'We had an issue creating your account, please try again.',
    voucherCardTitle: 'Claim your FREE gift!',
    voucherCardSubTitle: 'off your next shop*',
    voucherCardAddedTitle: 'Your FREE gift...enjoy!',
    appOnlyRewardVoucherType: 'REWARD_VOUCHER_APPONLY',
    joinPageDesc: 'Good things happen every time you shop with M&S Sparks. From big treats to little thank yous and a charity donation with every purchase, join Sparks for rewards you\'ll love.',
    hubPageDesc: 'Good things happen every time you shop with M&S Sparks. From big treats to little thank yous and a charity donation with every purchase.',
    charityPageDesc: 'Every time you shop with Sparks, whether in store or online, we donate to your chosen charity. Together, we\'ve raised almost €7 million so far. We\'ve spoken to our colleagues and listened to our customers to find out more about the causes that matter to them most, and have added 25 new charities to Sparks. Take a look below to discover all of our Sparks charities and the amazing work they do.',
    aboutPageDesc: 'Want to find out more about Sparks, the reward scheme from M&S? There are big treats, little thank yous and a charity donation with every purchase.',
    aboutBannerTitle: 'Love M&S, Love Savings, Love Sparks',
    aboutSparksSubTitle: 'Enjoy great savings on the things you love with Sparks',
    checkOffersText: 'Check your offers',
    aboutLinkCardText: 'Link your physical card',
    rewardTypeProduct: 'REWARD_PRODUCT',
    rewardTypeVoucher: 'REWARD_VOUCHER',
    rewardType2Choice: 'REWARD_2CHOICEPRODUCT',
    rewardTypeChristmas: 'REWARD_XMAS2020',
    rewardTypeShopForAYear: 'REWARD_SHOP_FOR_A_YEAR',
    rewardTypeRAFVoucher: 'REWARD_RAF_VOUCHER',
    rewardTypeRAFProduct: 'REWARD_RAF_PRODUCT',
    rewardTypeRAFDiscount: 'REWARD_RAF_DISCOUNT',
    personalisedOfferTitleTxt: 'PERSONALISED OFFERS',
    rewardTypeStreakComplete: 'REWARD_STREAK_COMPLETE',
    rewardTypeVoucherStreakComplete: 'REWARD_VOUCHER_STREAK_COMPLETE',
    rewardTypeAlwaysOnStreakComplete: 'REWARD_STREAK_ALWAYSON_COMPLETE',
    appOnlyType: 'APPONLY',
    streakTypeFlexi: 'FLEXI_STREAK',
    personalisedOfferTxt: 'We\'ll give you personalised offers based on the things you love. Add them and they\'ll be applied at checkout.',
    landingPageVideoUrlProspectiveCustomer: 'https://www.youtube.com/embed/9XDECsj4a34',
    landingPageVideoUrlExistingUser: 'https://www.youtube.com/embed/9XDECsj4a34',
    landingPageVideoSettings: '?fs=1&rel=0&enablejsapi=1&playerapiid=myytplayer&modestbranding=1',
    personalisedTreatTitleTxt: 'LOOK OUT FOR TREATS',
    personalisedTreatTxt: 'We\'ll surprise lucky customers with little thank yous, and every week in every store someone will get their shopping for free!',
    aboutSparksCharityButtonText: 'See all charities',
    aboutPageMobileTailoredToYouText: 'SPARKS AT YOUR FINGERTIPS',
    aboutPageMobileHowToUseBoldText1: 'Add your offers and',
    aboutPageMobileHowToUseBoldText2: 'rewards with just one tap',
    discoverSparksBannerTitleExistingCustomer: 'DISCOVER YOUR NEW SPARKS',
    discoverSparksBannerBodyExistingCustomer: 'Now there are even more benefits to being a Sparks customer',
    discoverSparksBannerLink: 'Explore Sparks',
    discoverSparksBannerTitleNewCustomer: 'DISCOVER REWARDS YOU\'LL LOVE',
    discoverSparksBannerBodyNewCustomer: 'There are lots of benefits to being a Sparks customer',
    appStoreAppDownloadHubLink: 'https://mandsapp.onelink.me/256943915/iOSSparksOffer',
    googlePlayAppDownloadHubLink: 'https://mandsapp.onelink.me/256943915/AndroidSparksOffer',
    iosMetaTag: '/ie/mysparks?intid=mobile_app_smartappbanner_from_sparks',
    bannerTitleTextMobile: 'GOOD THINGS HAPPEN<BR>EVERY TIME YOU SHOP',
    dotComPlusUrls: {
        'signOut': '/Logoff',
        'customerSearch': '/MSCSAdvancedSearchForm',
        'wrapup': '/RestoreOriginalUserSetInSession?catalogId=11551&wrapUp=true&langId=-24&wrapUpUrl=/webapp/wcs/stores/servlet/TopCategoriesDisplayView?catalogId=11551&langId=-24&storeId=10451&storeId=10451&intid=sparks_hub_signout'
    },
    chooseTreatTitleTop: 'You\'ve got',
    chooseTreatTitleBottom: 'a free gift',
    bookASlotExp: 'BOOK_A_SLOT',
    bookSlotDesc: 'Reserve a slot to shop in store, so you won\'t have to queue when you arrive.',
    bookSlotHeadBook: 'BOOK',
    bookSlotHeadAmp: '&',
    bookSlotHeadShop: 'SHOP',
    bookSlotCTA: 'Book now',
    voucherCardValueKeyText: 'VALUE',
    voucherCardExpiryKeyText: 'EXPIRY',
    voucherCardShowDetailLinktext: 'SHOW GIFT CODE',
    gitfCardCodeTitle: 'Gift Card',
    giftCardInStoreTitle: 'In-store gift card',
    giftCardOnlineTitle: 'Online gift card',
    giftCardCodeNumberKey: 'CARD NUMBER',
    giftCardCodePinKey: 'PIN',
    giftCardCodeBottomTextBold: 'Barcode not scanning?',
    giftCardCodeBottomBodyText: 'Enter the 30 digit number above manually at checkout',
    copy: 'COPY',
    christmasPopupGreet: 'Christmas is on us!',
    christmasPopupMessage: 'Congratulations, you\'ve got a €250 gift card to spend on whatever you like at M&S!',
    christmasPopupButton: 'See gift card',
    showVoucherButtonText: 'Show Christmas treat',
    showSparkscardButtonText: 'Show Sparks card',
    checkGCBalanceText: 'Check gift card balance',
    tsncs: 'Ts & Cs',
    congratulationsText: 'Congratulations!',
    christmasTreatText: 'HERE\'S YOUR SPARKS CHRISTMAS TREAT',
    checkGCBalanceURL: 'https://www.marksandspencer.com/ie/c/gift-card-balance',
    addressCaptureBannerTitle: 'Want to check out faster?',
    addressCaptureBannerDesc: 'Add a default billing and shipping address so that next time you shop all you\'ll need to do is enter your card details',
    addressCaptureBannerCta: 'Add your address',
    addressSuccessBanner: 'Success! You\'ve saved an address',
    addresSuccessBannerDesc: 'You can review and update your details at any time by selecting \'Personal & Contact Details\' from the menu',
    addressSuccessBannerCta: 'See your account',
    myAccountLink: '/webapp/wcs/stores/servlet/MSMyAccountView?langId=-24&catalogId=11551&storeId=10451',
    addressCaptureExp: 'ADDRESS_CAPTURE',
    giftCardTsandCsProdLink: 'https://www.marksandspencer.com/ie/c/faqs/legal-and-ethical-policies/what-are-the-gift-cardegift-card-terms-and-conditions',
    sfyNotificationPopupAgentGreet: 'YOU\'VE GOT A TREAT…',
    sfyNotificationPopupAgentMessage: 'You\'re this week\'s lucky Sparks customer and you\'ve got a big treat on us!',
    sfyNotificationPopupAgentButton: 'Verify customer',
    sfyNotificationPopupCustomerMessage: 'One of our customer support assistants will be in touch soon to discuss the treat with you in more detail.',
    sfyNotificationPopupCustomerSeperator: '- OR -',
    sfyNotificationPopupCustomerMessage2: 'Call us on ',
    sfyNotificationPopupCustomerMessage2a: '0333 014 8423',
    sfyNotificationPopupCustomerMessage3: 'Mon - Sun 8am - 8pm',
    sfyNotificationPopupCustomerButton: 'View your offers',
    sfyNotificationPopupCustomerVerifiedMessage: 'Your digital gift card is waiting for you in your hub. Enjoy a year of M&S shopping for free!',
    sfyNotificationPopupCustomerVerifiedButton: 'View digital gift card',
    shoppingForAYearQuestionText: 'Are you over 18?',
    shoppingForAYearTitle: 'CUSTOMER VERIFICATION',
    shoppingForAYearInstructionText: 'Can you tell me the last 10 digits of your Sparks card number',
    shoppingForAYearPopupButtonText: 'Submit',
    sfyVerifyFailMessage: 'This is not the card number linked to this account',
    marchSparksAppTitleOne: 'CELEBRATE SUMMER',
    marchSparksAppTitleTwo: 'WITH SPARKS',
    marchSparksAppDesc: 'Don’t miss out! From 12-21 May we’re giving away thousands of offers every day',
    cardInUseErrorKey: 'ONBOARD_SUBMIT_CARD_IN_USE',
    shoppingForAYearTryAgainButtonText: 'Try again',
    verifiedPopupAgentGreet: 'Verification success!',
    verifiedPopupAgentMessage: 'Customer has been verified.',
    verifiedPopupAgentButton: 'View your offers',
    sfyFailTitle: 'Sorry',
    errorFortarget: 'Sorry , we weren\'t able to load your balance',
    sfyFailBody: 'You are not eligible for this offer. This offer cannot be used if you are not 18 years old or above.',
    activateFailedMessage: 'Sorry, customer is verified but activation has failed. Please try again',
    referAFriendExp: 'REFER_A_FRIEND',
    referFriendTitle: 'REFER FRIENDS, EARN REWARDS',
    referFriendDesc: 'Invite your friends, you get €5 off your friends get €5 off. Win-win!',
    referFriendLink: 'Refer your friends',
    referFriendPageTitle: 'REFER A FRIEND',
    referFriendPageDesc: 'Invite your friends, you get €5 off or what offer is, your friends get €5 off. Win-win!',
    referFriendPageWorksTitle: 'How it Works',
    referFriendPageWorksShare: 'Share Sparks',
    referFriendPageWorksShop: 'They Shop',
    referFriendPageWorksEnjoy: 'Earn Rewards',
    referFriendPageWorksShareDesc: 'Share your unique referral link with up to five friends',
    referFriendPageWorksShopDesc: 'They\'ll get access to exciting new Sparks offers once they register',
    referFriendPageWorksEnjoyDesc: 'Once they\'ve shopped we\'ll send you a new Sparks reward to say thanks',
    rafLinkTitle: 'YOUR UNIQUE LINK',
    rafCopyCTA: 'Copy Link',
    rafFaceBook: 'SHARE',
    rafWhatsapp: 'MESSAGE',
    rafTwitter: 'TWEET',
    rafMail: 'GMAIL',
    rafPageTitleText: 'YOU\'VE BEEN REFERRED TO JOIN SPARKS',
    rafPageDescText: 'From big treats to little thank yous and a charity donation with every purchase',
    digitalReceiptsText: 'DIGITAL_RECEIPTS_JOURNEY',
    digitalReceiptsTitle: 'Go digital',
    digitalReceiptsDescription: 'Tired of losing receipts? Go digital and we\'ll email your receipts for in-store purchases straight to your inbox. Fast, easy and convenient.',
    digitalReceiptsToggleOff: 'Switch on digital receipts',
    digitalReceiptsToggleOn: 'Great! You\'ll now receive digital receipts',
    eReceiptExp: 'ERECEIPTS',
    ereceiptErrorMessage: 'Something went wrong, please try again.',
    sparksConsentTitle: 'You\'re missing out',
    sparksConsentTitleSuccess: 'Success!',
    sparksConsentDescription: 'Don\'t miss out on personalised offers, treats and surprises from Sparks, including the chance to get your shopping for free!',
    sparksConsentDescriptionSuccess: 'Thanks for signing up to Sparks. You\'ll now receive rewards, offers, treats and surprises, just for you.',
    sparksConsentToggleOff: 'Sign up for Sparks',
    sparksConsentToggleOn: 'You\'re all set',
    sparksConsentExp: 'SPARKS_EMAIL',
    tgtExpErrorMessage: 'Something went wrong, please try again.',
    marketConsentTitle: 'Never miss a thing',
    marketConsentDescription: 'We will send you exclusive offers, rewards, promotions and news via email and/or text about our products and services and those offered by our partners. If you change your mind. You can opt out any time.',
    marketConsentDescriptionSuccess: 'Thanks for subscribing. You can opt out at any time by changing your preferences.',
    marketConsentToggleOff: 'Subscribe',
    marketConsentExp: 'MARKETING_EMAIL',
    viewStreakButtonText: 'See your stamps',
    activateStreakButtonText: 'Start earning',
    howToEarnText: 'Full details',
    streakTitle: 'Earn a FREE ',
    activeStreakTextPart1: 'Buy ',
    activeStreakTextPart2: ' more to get a FREE ',
    streakHeader: 'Save with Sparks',
    streakTarget: 4,
    mockBalance: '2.00',
    streakOfferStamp1Greet: 'You\'ve earned<BR> your first stamp!',
    streakOfferStamp1Greet2: 'You\'re off to a great start.<BR> Buy <b>3</b> more to get your <b>FREE</b> ',
    streakOfferStamp1ButtonText1: 'See your progress',
    streakOfferStamp1URL: 'Full details',
    streakOfferCompleteGreet: 'You\'ve earned <BR><b>a FREE </b>',
    streakOfferCompleteGreet2: 'Next time you\'re in store scan your preferred <offername> and Sparks card - it\'s on us!',
    streakOfferCompleteButtonText: 'View your reward',
    streakOfferCompleteURL: 'Full details',
    qrTreatNotificationTitle: 'A treat for you',
    qrTreatNotificationMessage: 'Thanks for scanning your QR code. To claim your treat, sign in or register with Sparks',
    qrTreatNotificationButton: 'Go to Sparks',
    treatCampaign: 'qrcode_generic',
    confirmAddressText: 'Confirm address',
    addressWCSErrMsg: 'Something went wrong, Please try after sometime',
    referralPageDesc: 'Share your unique referral link with friends, they\'ll get exciting new Sparks offers once registered, and you\'ll get a new reward once they shopped.',
    rafTreatNotificationTitle: 'CONGRATULATIONS',
    rafTreatNotificationMessage: 'Your friend has joined Sparks, you have a new reward waiting in your Sparks hub',
    rafTreatNotificationButton: 'Check your offers',
    referralTandC: 'Full Ts&Cs can be ',
    referralTandCLink: 'found here.',
    referralTandCHref: 'https://www.marksandspencer.com/ie/c/faqs/legal-and-ethical-policies/sparks-benefits-terms-and-conditions',
    referralFandQ: 'Click ',
    referralforFandQ: 'for FAQs',
    referralFandQLink: 'here',
    referralFandQHref: 'https://www.marksandspencer.com/c/help/sparks-refer-a-friend',
    qrcodePageDesc: 'Scan QR and get new exciting new Sparks offers and new reward.',
    qrCodeErrMsg: 'Something went wrong',
    sasFirstPurchaseGreet1: 'You\'re on your way<BR> to €<save> off',
    sasFirstPurchaseGreet2: 'Well done, you\'re closer to earning €<save> off your next shop. Spend €<spend> on <offername> in store to earn your reward',
    sasFirstPurchaseButtonText: 'See your progress',
    sasFirstPurchaseURL: 'Full details',
    streakSASActivatedSpent: 'SPENT',
    streakSASActivatedCardText: 'Spend €<remainder> more to receive your €<save> reward',
    streakSASOfferCompleteGreet: 'You\'ve earned <BR><b><save> off your next shop</b>',
    streakSASOfferCompleteGreet2: 'Add your reward and it\'ll be automatically applied when you next shop online or scan your card at the till in store',
    streakSASOfferCompleteButtonText: 'Add reward to Sparks card',
    streakSASOfferCompleteURL: 'Full details',
    bankTreatPopUpTitle: 'CONGRATULATIONS',
    bankTreatPopUpMessage: 'you got Treat from bank campaign, Signin for sparks for more offers, Happy shopping',
    registerGenericCampaign: '/webapp/wcs/stores/servlet/MSResUserRegistration?catalogId=11551&myAcctMain=1&langId=-24&storeId=10451',
    carouselTitlePattern: 'Women|women',
    carouselPattern: 'offersPageComponent',
    mnsOffersTitle: 'Latest M&S Offers',
    throttle: {
        mnsOfferThrottle: 10
    },
    assistanceTitle: 'ASSISTANCE',
    assistanceAccount: 'Your account',
    assistanceFaq: 'FAQs',
    assistanceSparks: 'How to use Sparks',
    assistanceCardLink: 'Link my physical card',
    assistancePreference: 'Marketing preferences',
    yourAccountUrl: '/webapp/wcs/stores/servlet/MSMyAccountView?catalogId=11551&myAcctMain=1&langId=-24&storeId=10451',
    faqsUrl: '/ie/c/faqs/sparks-faq',
    aboutUrl: '/ie/mysparks/about',
    marketingPreferencesUrl: '/webapp/wcs/stores/servlet/MSCallMarketingPreferencesCmd?catalogId=11551&langId=-24&storeId=10451',
    appOnlyOfferTitle: 'EXCLUSIVE APP OFFER',
    appOnlyOfferTextAppend: '. Only in the M&S app',
    classNameIdentifer: 'roi',
    countdownBannerType: 'BANNER_COUNTDOWN',
    eReceiptPageContentText: 'Opt in to email receipts now to save paper and do away with lost or damaged printed receipts.',
    eReceiptPageContentDesc: 'We\'ll send your receipt to the email you signed up with, and always save a copy in the M&S app.',
    eReceiptOptinText: 'Opt in to email receipts',
    eReceiptOptinLabel: 'Opt in to email receipts',
    eReceiptOptinSuccessMsg: 'Your Digital Receipts preferences have been saved successfully',
    eReceiptPageCtaText: 'Save',
    eReceiptSuccessMsg: 'Your Digital Receipts preferences have been saved successfully',
    eReceiptSubText: 'Email receipts can be used for refunds, returns and exchanges. Please note, receipt emails may contain additional marketing content.',
    eReceiptPagePref: 'Visit <pref_location> to change your email preferences.',
    eReceiptPageTerms: 'Terms & Conditions',
    eReceiptPageAgree: '*If you\'ve agreed to the use of cookies and/or to receive marketing communications, you have the right to withdraw your consent at any time.',
    eReceiptPagePolicy: 'Please see our <data_location> for more information',
    eReceiptPrefHref: '/MSCallMarketingPreferencesCmd?catalogId=11551&langId=-24&storeId=10451',
    eReceiptTermsHref: '/ie/c/faqs/legal-and-ethical-policies/sparks-terms-and-conditions',
    eReceiptPolicyHref: '/ie/c/faqs/legal-and-ethical-policies',
    charityBannerTitle: 'DOUBLE DONATION',
    appDownloadElement: 'https://mandsapp.onelink.me/256943915/6c4104a9',
    charityBannerMessage: 'Throughout May, every time you shop with Sparks we’ll donate 2 cents to your chosen charity',
    eReceiptPageLink: '/ie/mysparks/eReceipt',
    eReceiptPopupLink: '/ie/mysparks/eReceipt#intid=sparks_hub_popup_digital-receipts-never-lose-a-receipt-again',
    qrToolLink: '/ie/mysparks/qrtool',
    yourSparks: 'Even more with Sparks',
    thumbnailsScanTitle: 'Scan & Shop',
    thumbnailsScanDesc: 'Never queue at the checkout again with Scan & Shop',
    thumbnailsLiveTitle: 'Virtual events',
    thumbnailsLiveDesc: 'Sign up to our virtual events and explore past ones',
    thumbnailsReciptTitle: 'Digital receipts',
    thumbnailsReciptDesc: 'Receive email receipts for transactions made in-store',
    scanAndShopUrl: 'https://www.marksandspencer.com/c/scan-and-shop',
    sparkLiveUrl: 'https://sparkslive.marksandspencer.com/events-archive',
    digitalErecipt: 'https://www.marksandspencer.com/MSRetrieveDigitalReceiptsPrefCmd?catalogId=11551&errorViewName=MSMyAccountView&langId=-24&storeId=10451&intid=sparks_thumbnail',
    pageSectionTitle: 'Sparks offers',
    twelveDaysofSparksLink: '/ie/mysparks/12daysofsparks#intid=spa_hub_all_bnr_advent-calendar_discover-now',
    twelveDaysofSparksOfferCount: 12,
    ACbackToSparksText: 'Back to Sparks',
    AChomeScreenDescriptionText: 'The Christmas countdown is on! Come back every day to unlock a new reward',
    AChomeScreenHowItWorksText: 'How it works',
    AChomeScreenAppDownloadText: 'Come back every day – or you’ll miss your reward. Use the app for extra time to open. Scan the QR code to download ',
    AChomeScreenAppDownloadTextMob: 'Come back every day – or you’ll miss your reward. Use the app for extra time to open',
    adventCalendarTomorrow: {
        advertCalendertitle: 'Come back tomorrow!',
        advertCalenderDesc: 'Good things come to those who wait. But you can check out what rewards you’ve collected already.'
    },
    adventCalendarFuture: {
        advertCalendertitle: 'No peeking! ',
        advertCalenderDesc: 'You’re a bit early, come back on the correct day to unlock this door.Check out what rewards you’ve unlocked already'
    },
    adventCalendarMissed: {
        advertCalendertitle: 'Oh snow!',
        advertCalenderDesc: 'Sorry, you didn’t open this door in time. But you can check out what rewards you’ve collected already'
    },
    adventCalendarYesterday: {
        advertCalendertitle: 'Don’t miss out',
        advertCalenderDesc: 'You can still open yesterday’s door – just download the M&S app'
    },
    adventCalendarUnlocked: {
        advertCalendertitle: 'You\'ve unlocked 13',
        advertCalenderDesc: 'Congratulations! You\'ve opened all 12 doors and have unlocked a bonus 13th reward on the app. Download the M&S app to unlock now'
    },
    adventCalendarViewButton: 'View my offers',
    AChomeViewOfferRedirectURLParam: '?viewcalendaroffers#intid=sparksnav_advent-calendar_offer_view-added-offers',
    AChomeOfferDetailsShopOfferText: 'Shop the offer',
    AChomeOfferDetailsViewAddedOfferText: 'View added offers',
    AChomeOfferDetailsExpirePreText: 'Expires',
    AChomeOfferDetailsSingleUseText: 'Single use',
    AChomeOfferDetailsTermsHeaderText: 'Terms and conditions',
    AChomeOfferDetailsMoreInformationText: 'More information',
    AChomeOfferDetailsLessInformationText: 'Less information',
    AChomeOfferDetailsRedeemedOfferText: 'You have redeemed this offer',
    AChomeOfferDetailsInStoreAndOnlineText: 'In-store & online',
    AChomeOfferDetailsInStoreText: 'In-store',
    AChomeOfferDetailsOnlineText: 'Online',
    adventCalendarBannerHeader: '12 DAYS OF',
    adventCalendarBannerTitle: 'We’re giving away 1,000s of treats! Plus, personalised offers and exclusive competitions. Scan the QR code to download the M&S app for an even more magical experience',
    adventCalendarBannerTitleMob: 'We’re giving away 1,000s of treats! Plus, personalised offers and exclusive competitions. Download the app for a more magical experience',
    adventCalendarBannerTitlePost12Days: 'Congratulations! You’ve unlocked all 12 rewards. Your golden reward will arrive tomorrow…',
    adventCalendarBannerBodyPost12Days: '',
    adventCalendarBannerButtonText: 'Unlock today’s reward',
    adventCalendarOfferAddedTitle: '12 days of Sparks',
    ACHIWHeader: 'How it works',
    ACHIWDescription: 'Between 1 - 12 December, a new reward will be hidden behind your door every day.   Just tap to unlock and your reward will automatically appear in your ‘added offers’.   You have 24-hours to unlock each reward, download the app for extra time – so don’t miss out. And no peeking ahead either! Doors can’t be opened early.   Open all 12 days and you’ll receive a bonus golden reward on day 13',
    adventCalendarShoptheOffer: '#intid=sparksnav_advent-calendar_offer_shop-offer_',
    adventCalendarEndDate: '2022-12-13',
    sparksAppTitle: 'Your Sparks card and benefits are also digital',
    sparksAppDesc: 'Download the M&S app to scan your card straight from your phone, and keep track of offers and rewards.',
    sparksAppMobDesc: 'Download the M&S app to scan your card straight from your phone, and keep track of offers and rewards.',
    thumbnailsStampTitle: 'Sparks Stamps ',
    thumbnailsStampDesc: 'Collect a stamp every time you buy an M&S hot drink and get your 7th on us',
    POSCampaignTitle: 'Love M&S, Love Savings, Love Sparks',
    POSCampaignText: 'Enjoy great savings on the things you love with Sparks',
    POSCampaigntitle1:'JOIN SP',
    POSCampaigntitle2: 'RKS FOR REWARDS YOU\'LL LOVE',
    POSBenefitsPersonalisedOffers: 'Offers just for you',
    POSBenefitsPersonalisedOffersDesc: 'Get personalised offers on the things you love.',
    POSBenefitsChanceToGet: 'The chance to get what you’re buying for free',
    POSBenefitsChanceToGetDesc:'Every week in store, we\'ll treat a Sparks customer to the shopping they\'re buying, for free.',
    POSBenefitsLittleThankYou: 'Little thank yous, just because',
    POSBenefitsLittleThankYousDesc:'Every day we\'ll surprise lucky customers with a little gift.',
    POSBenefitsCharityDonation: 'Charity donations',
    POSBenefitsCharityDonationDesc: 'We\'ll make a donation to your chosen charity every time you shop.',
    POSBenefitsChanceToWin: 'Enjoy a hot drink on us ',
    POSBenefitsChanceToWinDesc: 'Buy six hot drinks in store and get one for free ',
    variantBannerTitle1:'YOU GET MORE WITH',
    variantBannerTitle2:'SP',
    variantBannerTitle3:'RKS',
    variantBannerMobileTitle1:'YOU GET MORE ',
    variantBannerMobileTitle2:'WITH ',
    variantBannerSubtext:'10% off when you sign up to Sparks*',
    variantBannerBtn:'Sign up',
    variantBannerAlreadyMember:'Already a member?',
    variantBannerViewRewards:'Sign in to view your rewards',
    myAccount: 'my account',
    digitalTitle: 'Never lose a receipt again!',
    digitalDesc1:'As a valued Sparks customer, you have been selected to go paperless!',
    digitalDesc2:'Your receipts will now be safely stored in your Sparks account on the M&S app and website, instead of being printed in store.',
    digitalDesc3:'A copy will be sent to you via email too.',
    digitalReceiptPopupButton:'Thanks, got it!',
    digitalLink:'Change your receipt settings',
    digitalReceiptPopup: 'OPTIN_RECEIPTS',
    stampsThumbnailLink: 'https://www.marksandspencer.com/mysparks/qrcode?campaign=ALWAYSON_APPONLY_STREAK_COFFEE_12_2021&extid=qr_sparks_ALWAYSON_APPONLY_STREAK_COFFEE_12_2021',
    prizeDraw: {
        badge: 'Prize Draw',
        closeDatePrefix: 'Draw closes by',
        enterCta: 'Enter now',
        enteredCta: 'More details'
    }
};
